import { lightInsuranceLogos } from '../../domain/useCases/insurance/insuranceLogos'

const {
  bluecrossBlueshield,
  aetna,
  cigna,
  humana,
  carelonBehavioralHealth,
  anthem,
  unitedHealthcare,
  healthnet,
  tricare,
  optum
} = lightInsuranceLogos

export const INSURANCE_OVERVIEW_MENU_OPTIONS = [
  {
    title: 'BlueCross BlueShield',
    slug: '/insurance/bluecross-blueshield',
    img: bluecrossBlueshield
  },
  {
    title: 'Aetna',
    slug: '/insurance/aetna',
    img: aetna
  },
  {
    title: 'Cigna',
    slug: '/insurance/cigna',
    img: cigna
  },
  {
    title: 'Humana',
    slug: '/insurance/humana',
    img: humana
  },
  {
    title: 'Carelon Behavioral Health',
    slug: '/insurance/carelon-behavioral-health',
    img: carelonBehavioralHealth
  },
  {
    title: 'Anthem',
    slug: '/insurance/anthem',
    img: anthem
  },
  {
    title: 'United Healthcare',
    slug: '/insurance/united-healthcare',
    img: unitedHealthcare
  },
  {
    title: 'HealthNet',
    slug: '/insurance/healthnet',
    img: healthnet
  },
  {
    title: 'Tricare',
    slug: '/insurance/tricare',
    img: tricare
  },
  {
    title: 'Optum',
    slug: '/insurance/optum',
    img: optum
  }
]

const CLOUDINARY_URL =
  'https://res.cloudinary.com/rehabpath/image/upload/w_80,h_80/'
const IMAGE_FORMAT = '.png'
const IMAGE_SUFFIX = '-thumbnail'
const generateImageURL = (slug) =>
  `${CLOUDINARY_URL}${slug}${IMAGE_SUFFIX}${IMAGE_FORMAT}`

export const LOCATION_OVERVIEW_MENU_OPTIONS = [
  {
    title: 'California',
    slug: '/california',
    locationType: 'Region',
    locationName: 'California, USA',
    img: generateImageURL('california')
  },
  {
    title: 'Florida',
    slug: '/florida',
    locationType: 'Region',
    locationName: 'Florida, USA',
    img: generateImageURL('florida')
  },
  {
    title: 'Europe',
    slug: '/europe',
    locationType: 'Continent',
    locationName: 'Europe',
    img: generateImageURL('europe')
  },
  {
    title: 'Canada',
    slug: '/canada',
    locationType: 'Country',
    locationName: 'Canada',
    img: generateImageURL('canada')
  },
  {
    title: 'Asia',
    slug: '/asia',
    locationType: 'Continent',
    locationName: 'Asia',
    img: generateImageURL('asia')
  },
  {
    title: 'Australia',
    slug: '/australia',
    locationType: 'Country',
    locationName: 'Australia',
    img: generateImageURL('australia')
  }
]

export const CONDITIONS_OVERVIEW_MENU_OPTIONS = [
  {
    title: 'Alcohol',
    term: 'Alcohol',
    link: '/condition/alcohol'
  },
  {
    title: 'Anxiety',
    term: 'Anxiety',
    link: '/condition/anxiety'
  },
  {
    title: 'Eating Disorders',
    term: 'Eating Disorders',
    link: '/condition/eating-disorders'
  },
  {
    title: 'Trauma',
    term: 'Trauma',
    link: '/condition/trauma'
  },
  {
    title: 'Detox',
    term: 'Detox',
    link: '/care/detox'
  },
  {
    title: 'Depression',
    term: 'Depression',
    link: '/condition/depression'
  },
  {
    title: 'Gambling',
    term: 'Gambling',
    link: '/condition/gambling'
  },
  {
    title: 'Co-Occurring Disorders',
    term: 'Co-Occurring Disorders',
    link: '/condition/co-occurring-disorders'
  }
]

export const CLIENTELE_OVERVIEW_MENU_OPTIONS = [
  {
    title: 'Men',
    term: 'Men',
    link: '/clientele/men'
  },
  {
    title: 'Women',
    term: 'Women',
    link: '/clientele/women'
  },
  {
    title: 'Teens',
    term: 'Adolescents',
    link: '/clientele/adolescents'
  },
  {
    title: 'Executives',
    term: 'Executives',
    link: '/clientele/executives'
  },
  {
    title: 'Young Adults',
    term: 'Young Adults',
    link: '/clientele/young-adults'
  },
  {
    title: 'Professionals',
    term: 'Professionals',
    link: '/clientele/professionals'
  },
  {
    title: 'LGBTQ+',
    term: 'LGBTQ+',
    link: '/clientele/lgbtq'
  }
]

export const RESOURCES_OVERVIEW_MENU_OPTIONS = [
  {
    title: 'Treatment–And Hope–for People With Co-Occurring Disorders',
    slug: '/resources/treatment-and-hope-for-people-with-co-occurring-disorders/',
    img: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,w_121/treatment-and-hope-for-people-with-co-occurring-disorders'
  },
  {
    title: 'Why Choose Residential Rehab? 8 Benefits to Consider',
    slug: '/resources/8-benefits-of-residential-rehab/',
    img: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,w_121/8-benefits-of-residential-rehab'
  },
  {
    title: 'Cost of Rehab and Insurance Coverage: Frequently Asked Questions',
    slug: '/resources/cost-of-rehab-and-insurance-coverage-faqs/',
    img: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,w_121/cost-of-rehab-and-insurance-coverage-faqs'
  },
  {
    title: 'How Long Does It Take to Detox?',
    slug: '/resources/how-long-does-it-take-to-detox/',
    img: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,w_121/how-long-does-it-take-to-detox'
  },
  {
    title: 'Finding the Right Rehab for Your Teen or Young Adult',
    slug: '/resources/teen-rehabs/',
    img: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,w_121/teen-rehabs'
  },
  {
    title: 'How to Find a Job After Rehab',
    slug: '/resources/how-to-find-job-after-rehab/',
    img: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,w_121/how-to-find-job-after-rehab'
  },
  {
    title: '9 Ways To Help Someone With An Addiction',
    slug: '/resources/9-ways-to-help-someone-with-an-addiction/',
    img: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,w_121/9-ways-to-help-someone-with-an-addiction'
  },
  {
    title: 'Goals of Depression Treatment (AAA)',
    slug: '/resources/goals-of-depression-treatment-aaa/',
    img: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,w_121/goals-of-depression-treatment-aaa'
  }
]
